/**
 * /semanadafisiogg — LP-catálogo da Semana da Fisioterapia para tráfego Google.
 *
 * Idêntica à /semanadafisio, porém as 6 pós apontam para as LPs Wix /gg
 * (pré-checkout com cupom SEMANADAFISIOGG). Certificações, Star Cursos e
 * Agente IA usam as mesmas LPs da página principal.
 */
import { createFileRoute } from "@tanstack/react-router";

import { SemanaFisioPage } from "@/components/lps/SemanaFisioPage";
import { getAcoesStateFn } from "@/lib/campanhas/acoes.functions";

const URL_GG = "https://fisioemortopedia.com.br/semanadafisiogg";

export const Route = createFileRoute("/semanadafisiogg")({
  validateSearch: (search: Record<string, unknown>): { preview?: boolean } =>
    search.preview === "1" || search.preview === 1 || search.preview === true
      ? { preview: true }
      : {},
  head: () => ({
    meta: [
      { title: "Semana da Fisioterapia · Ofertas" },
      {
        name: "description",
        content:
          "Semana da Fisioterapia da FEO: pós-graduações, certificações, Star Cursos e Agente IA com até 80% de desconto. Ofertas renovadas todos os dias às 23h59.",
      },
      { property: "og:title", content: "Semana da Fisioterapia · Ofertas" },
      {
        property: "og:description",
        content: "Pós, certificações, Star Cursos e Agente IA com até 80% de desconto na maior ação do ano.",
      },
      { property: "og:url", content: URL_GG },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Semana da Fisioterapia · Ofertas" },
      {
        name: "twitter:description",
        content: "Até 80% de desconto em pós, certificações, Star Cursos e Agente IA.",
      },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: URL_GG }],
  }),
  loader: () => getAcoesStateFn(),
  component: SemanaFisioGgRoute,
});

function SemanaFisioGgRoute() {
  const acoes = Route.useLoaderData();
  const { preview } = Route.useSearch();
  return <SemanaFisioPage ativa={Boolean(acoes?.semanadafisio?.ativa) || preview === true} variant="gg" />;
}
